import axios from "axios";

const USER_BASE_URL = "https://app-apim-admin-cms-stage-erhsf2bafdenc7ft.australiasoutheast-01.azurewebsites.net/";
const CMS_BASE_URL = "https://api-stage.synnexb2b.com.au/stage";

const userApi = axios.create({
  baseURL: USER_BASE_URL,
});
// userApi.interceptors
// Orchid Core CMS Base URL
const cmsApi = axios.create({
  baseURL: CMS_BASE_URL,
});
export { userApi, cmsApi };